module.exports = __webpack_public_path__ + "img/icon-fail.7b037ce6.jpg";